export default "__VITE_ASSET__CEAhMInV__"